import { getSession,getCookie, getDocumentoID, getGeneroID, getZone, getEdad,getPrecio,getPrecioPlus, getTotal, getTotalPlus, getPrecioConecta } from "./functions";
import { getFbc } from "./facebook";
import { REFERRER_COOKIE } from "./origen";
import Misc from "@/store/Misc.js";
import Conecta from "@/store/Conecta";
import VueCookies from 'vue-cookies';

const getCookieByName = name =>
{
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return undefined;
}

const InyectTrackingCookies = FormPayload =>
{
    // gbraid/wbraid/gad_source: Google Ads los manda en lugar del gclid desde iPhone/Safari.
    const Cookies = ["utm_source","utm_tracking","codigoPromotor","utm_medio","branch","gclid","codPromotor","gbraid","wbraid","gad_source"]

    for(const Cookie of Cookies)
    {
        const CookieValue = getCookieByName(Cookie);
        if(CookieValue) FormPayload.append(Cookie,CookieValue);
    }

    // De donde llego cuando no trae UTM: host del sitio que linkeo o "directo".
    const Referrer = getCookieByName(REFERRER_COOKIE);
    if(Referrer) FormPayload.append("referrer",Referrer);

    // El fbc no sale de una cookie con ese nombre: es la _fbc del pixel o la urg_fbc que
    // armamos con el fbclid. Viaja en cada paso del embudo para que el aviso de carrito
    // abandonado que sale a Sirena lo lleve, igual que el gclid.
    const Fbc = getFbc();
    if(Fbc) FormPayload.append("fbc",Fbc);

    return FormPayload;
}

// El domicilio de envio puede ser distinto al del titular (paso "Direccion de envio"),
// asi que se persiste completo y con las mismas claves que usa Conecta.Envio.domicilio.
// Si solo se guardan calle/altura/piso, al reanudar la sesion en venta asistida el resto
// de los campos queda con el domicilio del titular que copio setValidateZone.
const AppendShipping = (formData, Envio) =>
{
    const Domicilio = (Envio && Envio.domicilio) || {};
    const Campos = [
        "cp","provincia","ciudad","calle","numero","piso","torre","departamento",
        "lote","manzana","barrio","entreCalles","referencia"
    ];

    formData.append("body[shipping][modo]", (Envio && Envio.modo) || "home");

    for(const Campo of Campos)
    {
        formData.append(`body[shipping][domicilio][${Campo}]`, Domicilio[Campo] || "");
    }

    return formData;
}

export const cotizaTracking = async (PayloadTracking, productId = 3) =>
{
    try 
    {
        const Session = getSession();
        const Cookie = getCookie();

        const FormPayload = new FormData();

        // Resto el año actual a la edad para obtener la fecha de nacimiento
        var birthdate = `01/01/${new Date().getFullYear() - PayloadTracking.members[0].Edad}`.toString();

        // Envío nombre y edad sólo del primer miembro
        FormPayload.append("step",1);
        FormPayload.append("productid",productId);
        FormPayload.append("body[firstname]",PayloadTracking.members[0].Nombre);
        FormPayload.append("body[birthdate]",birthdate);
        FormPayload.append("body[email]",PayloadTracking.email);
        FormPayload.append("body[phone]",PayloadTracking.phone);

        const FormPayloadCooked = InyectTrackingCookies(FormPayload);

        await Session.post(`/tracking/${Cookie}/`,FormPayloadCooked);
    } 
    catch (error) 
    {
        console.log(error);   
    }
}

export const FirstStepConecta = async () =>
{
    try 
    {
        const Session = getSession();
        const Cookie = getCookie();

        const {Nombre,Apellido,Email,Tipo,Documento,Genero,Nacimiento,CodigoArea,Celular} = Conecta.state;

        const FormPayload = new FormData();    
        FormPayload.append("step",1);
        FormPayload.append("productid",4);
        FormPayload.append("response[valid]","");
        FormPayload.append("response[msg]","");
        FormPayload.append("body[firstname]",Nombre);
        FormPayload.append('body[lastname]', Apellido);
        FormPayload.append('body[email]', Email);
        FormPayload.append('body[document_type]', getDocumentoID(Tipo));
        FormPayload.append('body[document_number]', String(Documento));
        FormPayload.append('body[gender]', getGeneroID(Genero));
        FormPayload.append('body[birthday]',  Nacimiento);
        FormPayload.append('body[phone]', `${CodigoArea}-${Celular}`);

        const FormPayloadCooked = InyectTrackingCookies(FormPayload);

        await Session.post(`/tracking/${Cookie}`,FormPayloadCooked);

    } 
    catch (error) 
    {
        console.log(error);
    }
}

export const SecondStepConecta = async () =>
{
    try 
    {
        const Session = getSession();
        const Cookie = getCookie();

        const {Direccion} = Conecta.state;
        const {Localidad,Altura,Barrio,Calle,Latitud,Longitud} = Direccion;

        const FormPayload = new FormData();

        FormPayload.append("step",2);
        FormPayload.append("productid",4);
        FormPayload.append("body[zone]",Localidad.id);
        FormPayload.append("body[search_address]",Calle);
        FormPayload.append("body[search_number]",Altura);
        FormPayload.append("body[address]",Calle);
        FormPayload.append("body[address_number]",Altura);
        FormPayload.append("body[address2]","");
        FormPayload.append("body[neighborhood]",Barrio);
        FormPayload.append("body[lat]",Latitud);
        FormPayload.append("body[lng]",Longitud);
        FormPayload.append("response[code]","");
        FormPayload.append("response[valid]",true);
        FormPayload.append("response[msg]","");

        const FormPayloadCooked = InyectTrackingCookies(FormPayload);

        await Session.post(`/tracking/${Cookie}`,FormPayloadCooked);
    } 
    catch (error) 
    {
        
    }
}

export const ThirdStepConecta = async () =>
{
    try
    {
        const Session        = getSession();
        const CookieTracking = $cookies.get("tracking");

        const {Members,Nombre,Apellido,Email,Tipo,Documento,Genero,Nacimiento,Celular,Direccion, Product} = Conecta.state;

        const FormPayload = new FormData();
        FormPayload.append("step", 3);
        FormPayload.append("productid", 4);

        if(Members.length === 0)
        {
            FormPayload.append("body[extra_affiliates]", 0);
            FormPayload.append("response", "");
        }
        else
        {
            const LastMember = Members[Members.length - 1];
            
            const LastMemberEdad = getEdad(LastMember.Nacimiento);

            FormPayload.append("body[firstname]", LastMember.Nombre);
            FormPayload.append("body[lastname]", LastMember.Apellido);
            FormPayload.append("body[document_type]", getDocumentoID(LastMember.Documento));
            FormPayload.append("body[document_number]", LastMember.Documento);
            FormPayload.append("body[gender]", getGeneroID(LastMember.Genero));
            FormPayload.append("body[email]", LastMember.Email);
            FormPayload.append("body[zone]", Direccion.Localidad.id);
            FormPayload.append("body[search_address]", "");
            FormPayload.append("body[search_number]", "");
            FormPayload.append("body[address]", `${LastMember.Direccion.Calle} ${LastMember.Direccion.Altura} - ${LastMember.Direccion.Piso}`);
            FormPayload.append("body[address_number]", LastMember.Direccion.Altura);
            FormPayload.append("body[address2]", "");

            LastMember.Direccion.Barrio ? FormPayload.append("body[neighborhood]", LastMember.Direccion.Barrio) : FormPayload.append("body[neighborhood]", "");
            
            FormPayload.append("body[key]", 1);
            FormPayload.append("body[birthday]", LastMember.Nacimiento);
            FormPayload.append("body[phone]", LastMember.Celular);
            FormPayload.append("body[age]", LastMemberEdad);
            FormPayload.append("body[route]", LastMember.Direccion.Calle);
            FormPayload.append("body[city]", LastMember.Direccion.Localidad.title);
            FormPayload.append("body[coords][lat]", LastMember.Direccion.Latitud);
            FormPayload.append("body[coords][lng]", LastMember.Direccion.Longitud);

            const PrecioLastMember = !LastMember.Product ? getPrecioPlus(getEdad(LastMember.Edad)) : getPrecioConecta(LastMember.Product, LastMember.Edad);
            FormPayload.append("body[price]", PrecioLastMember.price);
            FormPayload.append("body[discount]", `${PrecioLastMember.discount}%`);
            FormPayload.append("body[total]", PrecioLastMember.price);
            FormPayload.append("body[discount_comment]", PrecioLastMember.discount_comment);
            FormPayload.append("body[price_extra_comments]", PrecioLastMember.extra_comments);
            FormPayload.append("body[document_type_title]", PrecioLastMember.Tipo);
            FormPayload.append("response[valid]", true);
            FormPayload.append("response[msg]", "");        
        }
        
        const FormPayloadCooked = InyectTrackingCookies(FormPayload);
        await Session.post(`/tracking/${CookieTracking}`,FormPayloadCooked);
    }
    catch (error) 
    {
        console.log(error);
    }
}

export const FourthStepConecta = async () =>
{
    try
    {
        const Session        = getSession();
        const CookieTracking = $cookies.get("tracking");

        const {Members,Antecedentes, EmergencyContacts,AntecedentesComentarios,Nombre,Apellido,Email,Tipo,Documento,Genero,Nacimiento,Celular,Direccion,Cupon, CodigoArea, Product, Ciudad, Provincia} = Conecta.state;

        const TipoDocumento = getDocumentoID(Tipo);
        const GeneroID = getGeneroID(Genero);
        const Edad = getEdad(Nacimiento);

        const Zona = getZone(Direccion.Localidad.title);

        const Precio = getPrecioConecta(Product, Edad);


        var formData = new FormData();

        formData.append('step', 4);
        formData.append('productid', 4);
        formData.append('body[people][0][firstname]', Nombre);
        formData.append('body[people][0][lastname]', Apellido);
        formData.append('body[people][0][email]', Email);
        formData.append('body[people][0][document_type]', TipoDocumento);
        formData.append('body[people][0][document_number]', Documento);
        formData.append("body[people][0][key]", 0);
        formData.append("body[people][0][gender]", Genero);
        formData.append("body[people][0][birthday]", Nacimiento);
        formData.append("body[people][0][age]", Edad);
        formData.append("body[people][0][phone]", Celular);
        formData.append("body[people][0][phone_area]", CodigoArea);
        formData.append("body[people][0][route]", Direccion.Calle);
        formData.append("body[people][0][address]", `${Direccion.Calle} - ${Direccion.Altura} - ${Direccion.Piso}`);
        formData.append("body[people][0][address_number]", Direccion.Altura);
        formData.append("body[people][0][cp]", Direccion.CP);
        formData.append("body[people][0][city]", Direccion.Localidad.title);
        formData.append("body[people][0][province]", Provincia || Direccion.Localidad?.province || "");
        formData.append("body[people][0][zone]", Direccion.Localidad.id); 
        formData.append("body[people][0][coords][lat]", Direccion.Latitud); 
        formData.append("body[people][0][coords][lng]", Direccion.Longitud);
        formData.append("body[people][0][piso]", Direccion.Piso || "");
        formData.append("body[people][0][torre]", Direccion.Torre || "");
        formData.append("body[people][0][departamento]", Direccion.Departamento || "");
        formData.append("body[people][0][lote]", Direccion.Lote || "");
        formData.append("body[people][0][manzana]", Direccion.Manzana || "");
        formData.append("body[people][0][entreCalles]", Direccion.EntreCalles || "");
        formData.append("body[people][0][observaciones]", Direccion.Observaciones || "");
        formData.append("body[people][0][geolocalizado]", Direccion.Geolocalizado ?? 1);
        formData.append("body[people][0][feeble_location]", Direccion.Feeble_location ? "1" : "0");
        formData.append("body[people][0][price]", Precio.price); 
        formData.append("body[people][0][discount]", `${Precio.discount}`); 
        formData.append("body[people][0][total]", Precio.price); 
        formData.append("body[people][0][discount_comment]", Precio.discount_comment); 
        formData.append("body[people][0][price_extra_comments]", Precio.extra_comments); 
        formData.append("body[people][0][document_type_title]", Tipo);
        formData.append("body[people][0][product]", Product);
        formData.append("body[people][0][antecedents]", Array.isArray(Antecedentes) ? JSON.stringify(Antecedentes) : JSON.stringify([Antecedentes]));
        formData.append("body[people][0][antecedents_comments]", typeof AntecedentesComentarios === 'object' ? JSON.stringify(AntecedentesComentarios) : AntecedentesComentarios);
        
        EmergencyContacts.forEach((c, idx) => {
        formData.append(`body[people][0][emergency_contacts][${idx}][Nombre]`, c.Nombre);
        formData.append(`body[people][0][emergency_contacts][${idx}][Apellido]`, c.Apellido);
        formData.append(`body[people][0][emergency_contacts][${idx}][Parentesco]`, c.Parentesco);
        formData.append(`body[people][0][emergency_contacts][${idx}][CodArea]`, c.CodArea);
        formData.append(`body[people][0][emergency_contacts][${idx}][Celular]`, c.Celular);
        });
        for (let index = 0; index < Members.length; index++) 
        {   

        
            const Member = Members[index];

            const TipoDocumentoMember = getDocumentoID(Member.Tipo);
            const GeneroIDMember = getGeneroID(Member.Genero);
            const MemberEdad = getEdad(Member.Nacimiento);
            const MemberZona = getZone(Member.Direccion.Localidad);

            const MemberPrecio = !Member.Product? getPrecioPlus(getEdad(Member.Edad)) : getPrecioConecta(Member.Product, Member.Edad);
            const IndexMember = index+1;

            formData.append(`body[people][${IndexMember}][firstname]`, Member.Nombre);
            formData.append(`body[people][${IndexMember}][lastname]`, Member.Apellido);
            formData.append(`body[people][${IndexMember}][document_type]`, TipoDocumentoMember);
            formData.append(`body[people][${IndexMember}][document_number]`, Member.Documento);
            formData.append(`body[people][${IndexMember}][gender]`, Member.Genero);
            formData.append(`body[people][${IndexMember}][email]`, Member.Email);
            formData.append(`body[people][${IndexMember}][zone]`, Member.Direccion.Localidad.id); 
            formData.append(`body[people][${IndexMember}][search_address]`, ``);
            formData.append(`body[people][${IndexMember}][search_number]`, ``);
            formData.append(`body[people][${IndexMember}][address]`, `${Member.Direccion.Calle} - ${Member.Direccion.Altura} - ${Member.Direccion.Piso}`);
            formData.append(`body[people][${IndexMember}][address_number]`, Member.Direccion.Altura);
            formData.append(`body[people][${IndexMember}][cp]`, Member.Direccion.CP);
            formData.append(`body[people][${IndexMember}][address2]`, ``);
            formData.append(`body[people][${IndexMember}][neighborhood]`, Member.Direccion.Barrio || ``);
            formData.append(`body[people][${IndexMember}][key]`, IndexMember);
            formData.append(`body[people][${IndexMember}][birthday]`, Member.Nacimiento);
            formData.append(`body[people][${IndexMember}][phone]`, Member.Celular);
            formData.append(`body[people][${IndexMember}][phone]`, Member.CodigoArea);
            formData.append(`body[people][${IndexMember}][age]`, MemberEdad);
            formData.append(`body[people][${IndexMember}][route]`, Member.Direccion.Calle); 
            formData.append(`body[people][${IndexMember}][city]`, Member.Direccion.Localidad.title);
            formData.append(`body[people][${IndexMember}][province]`, Member.Provincia || Member.Direccion.Localidad?.province || "");
            formData.append(`body[people][${IndexMember}][lat]`, Member.Direccion.Latitud);
            formData.append(`body[people][${IndexMember}][lng]`, Member.Direccion.Longitud);
            formData.append(`body[people][${IndexMember}][piso]`, Member.Direccion.Piso || "");
            formData.append(`body[people][${IndexMember}][torre]`, Member.Direccion.Torre || "");
            formData.append(`body[people][${IndexMember}][departamento]`, Member.Direccion.Departamento || "");
            formData.append(`body[people][${IndexMember}][lote]`, Member.Direccion.Lote || "");
            formData.append(`body[people][${IndexMember}][manzana]`, Member.Direccion.Manzana || "");
            formData.append(`body[people][${IndexMember}][entreCalles]`, Member.Direccion.EntreCalles || "");
            formData.append(`body[people][${IndexMember}][observaciones]`, Member.Direccion.Observaciones || "");
            formData.append(`body[people][${IndexMember}][geolocalizado]`, Member.Direccion.Geolocalizado ?? 1);
            formData.append(`body[people][${IndexMember}][feeble_location]`, Member.Direccion.Feeble_location ? "1" : "0");

            formData.append(`body[people][${IndexMember}][price]`, MemberPrecio.price);
            formData.append(`body[people][${IndexMember}][discount]`, `${MemberPrecio.discount}`);
            formData.append(`body[people][${IndexMember}][total]`, MemberPrecio.price);
            formData.append(`body[people][${IndexMember}][discount_comment]`, MemberPrecio.discount_comment);
            formData.append(`body[people][${IndexMember}][price_extra_comments]`, MemberPrecio.extra_comments);
            formData.append(`body[people][${IndexMember}][document_type_title]`, Member.Tipo);
            formData.append(`body[people][${IndexMember}][antecedents]`, Array.isArray(Member.Antecedentes) ? JSON.stringify(Member.Antecedentes) : JSON.stringify([Member.Antecedentes]));
            formData.append(`body[people][${IndexMember}][antecedents_comments]`, typeof Member.AntecedentesComentarios === 'object' ? JSON.stringify(Member.AntecedentesComentarios) : Member.AntecedentesComentarios);
            formData.append(`body[people][${IndexMember}][product]`, Member.Product);
            Member.EmergencyContacts.forEach((c, idx) => {
            formData.append(`body[people][${IndexMember}][emergency_contacts][${idx}][Nombre]`, c.Nombre);
            formData.append(`body[people][${IndexMember}][emergency_contacts][${idx}][Apellido]`, c.Apellido);
            formData.append(`body[people][${IndexMember}][emergency_contacts][${idx}][Parentesco]`, c.Parentesco);
            formData.append(`body[people][${IndexMember}][emergency_contacts][${idx}][CodArea]`, c.CodArea);
            formData.append(`body[people][${IndexMember}][emergency_contacts][${idx}][Celular]`, c.Celular);
            
        });
        }

        const Total = getTotalPlus();

        Cupon ? formData.append(`body[coupon_code]`, Cupon.alias ) : formData.append(`body[coupon_code]`, "" ) ;
        Cupon ? formData.append(`body[coupon]`, JSON.stringify(Cupon)) : formData.append(`body[coupon]`, "" ) ;
        
        const { Envio } = Conecta.state;
        AppendShipping(formData, Envio);

        formData.append("body[subtotal]", Total); 
        formData.append("body[discount]", 0); 
        formData.append("body[totalPersonDiscount]", `${Precio.discount}`); 
        formData.append("body[total]", Total); 
        formData.append("body[collect_people_data]", 1); 


        const FormPayloadCooked = InyectTrackingCookies(formData);
        await Session.post(`/tracking/${CookieTracking}`,  FormPayloadCooked);
    }
    catch (error) 
    {
        console.log(error);
    }
}

export const FifthStepConecta = async MethodPayment =>
{
    try 
    {
        const Session        = getSession();
        const CookieTracking = $cookies.get("tracking");

        const {Members,Nombre,Apellido,Email,EmergencyContacts,Tipo,Documento,Genero,Nacimiento,CodigoArea,Celular,Direccion,Price,Cupon, Product, Ciudad, Provincia} = Conecta.state;

        var formData = new FormData();

        const Total = getTotal();

        formData.append('step', 5);
        formData.append('productid', 4);
        formData.append('terms', 1);
        formData.append("terms_date", new Date().toISOString());

        formData.append('body[total]', Total);

        // Titular a nivel raíz (mismo naming que FirstStepConecta): el listado y el
        // buscador del admin leen body.firstname/lastname/email/phone/document_number,
        // sin esto la sesión aparece sin nombre cuando no tiene filas de pasos previos
        formData.append("body[firstname]", Nombre);
        formData.append('body[lastname]', Apellido);
        formData.append('body[email]', Email);
        formData.append('body[document_type]', getDocumentoID(Tipo));
        formData.append('body[document_number]', String(Documento));
        formData.append('body[gender]', getGeneroID(Genero));
        formData.append('body[birthday]', Nacimiento);
        formData.append('body[phone]', `${CodigoArea}-${Celular}`);
        formData.append('body[zone]', Direccion.Localidad.id);

        formData.append("body[people][0][age]", getEdad(Nacimiento));
        formData.append("body[people][0][key]",0);
        formData.append("body[people][0][city]",Direccion.Localidad.title);
        formData.append("body[people][0][province]",Provincia || Direccion.Localidad?.province || "");
        formData.append("body[people][0][zone]",Direccion.Localidad.id);
        formData.append("body[people][0][email]",Email);
        formData.append("body[people][0][phone]",`${CodigoArea}-${Celular}`);
        formData.append("body[people][0][price]",Price.price);
        formData.append("body[people][0][route]",Direccion.Calle);
        formData.append("body[people][0][total]",Price.price);
        formData.append("body[people][0][coords][lat]",Direccion.Latitud);
        formData.append("body[people][0][coords][lng]",Direccion.Longitud);
        formData.append("body[people][0][piso]", Direccion.Piso || "");
        formData.append("body[people][0][torre]", Direccion.Torre || "");
        formData.append("body[people][0][departamento]", Direccion.Departamento || "");
        formData.append("body[people][0][lote]", Direccion.Lote || "");
        formData.append("body[people][0][manzana]", Direccion.Manzana || "");
        formData.append("body[people][0][entreCalles]", Direccion.EntreCalles || "");
        formData.append("body[people][0][observaciones]", Direccion.Observaciones || "");
        formData.append("body[people][0][geolocalizado]", Direccion.Geolocalizado ?? 1);
        formData.append("body[people][0][feeble_location]", Direccion.Feeble_location ? "1" : "0");
        formData.append("body[people][0][gender]",Genero);
        formData.append("body[people][0][address]", `${Direccion.Calle} ${Direccion.Altura} - `);
        formData.append("body[people][0][birthday]", Nacimiento);
        formData.append(`body[people][0][discount]`, `${Price.discount}`);
        formData.append(`body[people][0][lastname]`, Apellido );
        formData.append(`body[people][0][firstname]`, Nombre );
        formData.append(`body[people][0][neighborhood]`, Direccion.Barrio );
        formData.append(`body[people][0][document_type]`, getDocumentoID(Tipo) );
        formData.append(`body[people][0][address_number]`, Direccion.Altura );
        formData.append(`body[people][0][cp]`, Direccion.CP );
        formData.append(`body[people][0][document_number]`, Documento );
        formData.append(`body[people][0][discount_comment]`, Price.discount_comment );
        formData.append(`body[people][0][document_type_title]`, Tipo );
        formData.append(`body[people][0][price_extra_comments]`, Price.extra_comments );
        formData.append(`body[people][0][product]`, Product);
        const { Antecedentes, AntecedentesComentarios } = Conecta.state;

        formData.append("body[people][0][antecedents]", Array.isArray(Antecedentes) ? JSON.stringify(Antecedentes) : JSON.stringify([Antecedentes]));
        formData.append("body[people][0][antecedents_comments]", typeof AntecedentesComentarios === 'object' ? JSON.stringify(AntecedentesComentarios) : AntecedentesComentarios);
        
        EmergencyContacts.forEach((c, idx) => {
        formData.append(`body[people][0][emergency_contacts][${idx}][Nombre]`, c.Nombre);
        formData.append(`body[people][0][emergency_contacts][${idx}][Apellido]`, c.Apellido);
        formData.append(`body[people][0][emergency_contacts][${idx}][Parentesco]`, c.Parentesco);
        formData.append(`body[people][0][emergency_contacts][${idx}][CodArea]`, c.CodArea);
        formData.append(`body[people][0][emergency_contacts][${idx}][Celular]`, c.Celular);
        });

        for (let IndexMember = 0; IndexMember < Members.length; IndexMember++)
        {
            const RealIndex = IndexMember + 1;
            const Member = Members[IndexMember];

            formData.append(`body[people][${RealIndex}][age]`, getEdad(Member.Nacimiento));
            formData.append(`body[people][${RealIndex}][key]`,RealIndex);
            formData.append(`body[people][${RealIndex}][city]`,Member.Direccion.Localidad.title);
            formData.append(`body[people][${RealIndex}][province]`,Member.Provincia || Member.Direccion.Localidad?.province || "");
            formData.append(`body[people][${RealIndex}][zone]`,Member.Direccion.Localidad.id);
            formData.append(`body[people][${RealIndex}][email]`,Member.Email);
            formData.append(`body[people][${RealIndex}][phone]`,`${Member.CodigoArea}-${Member.Celular}`);
            formData.append(`body[people][${RealIndex}][price]`,Member.Price.price);
            formData.append(`body[people][${RealIndex}][route]`,Member.Direccion.Calle);
            formData.append(`body[people][${RealIndex}][total]`,Member.Price.price);
            formData.append(`body[people][${RealIndex}][coords][lat]`,Member.Direccion.Latitud);
            formData.append(`body[people][${RealIndex}][coords][lng]`,Member.Direccion.Longitud);
            formData.append(`body[people][${RealIndex}][cp]`,Member.Direccion.CP);
            formData.append(`body[people][${RealIndex}][piso]`, Member.Direccion.Piso || "");
            formData.append(`body[people][${RealIndex}][torre]`, Member.Direccion.Torre || "");
            formData.append(`body[people][${RealIndex}][departamento]`, Member.Direccion.Departamento || "");
            formData.append(`body[people][${RealIndex}][lote]`, Member.Direccion.Lote || "");
            formData.append(`body[people][${RealIndex}][manzana]`, Member.Direccion.Manzana || "");
            formData.append(`body[people][${RealIndex}][entreCalles]`, Member.Direccion.EntreCalles || "");
            formData.append(`body[people][${RealIndex}][observaciones]`, Member.Direccion.Observaciones || "");
            formData.append(`body[people][${RealIndex}][geolocalizado]`, Member.Direccion.Geolocalizado ?? 1);
            formData.append(`body[people][${RealIndex}][feeble_location]`, Member.Direccion.Feeble_location ? "1" : "0");
            formData.append(`body[people][${RealIndex}][gender]`,Member.Genero);
            formData.append(`body[people][${RealIndex}][address]`, `${Member.Direccion.Calle} ${Member.Direccion.Altura} - `);
            formData.append(`body[people][${RealIndex}][birthday]`, Member.Nacimiento);
            formData.append(`body[people][${RealIndex}][discount]`, `${Member.Price.discount}`);
            formData.append(`body[people][${RealIndex}][lastname]`,  Member.Apellido );
            formData.append(`body[people][${RealIndex}][firstname]`, Member.Nombre );
            formData.append(`body[people][${RealIndex}][neighborhood]`, Member.Direccion.Barrio );
            formData.append(`body[people][${RealIndex}][document_type]`, getDocumentoID(Member.Tipo) );
            formData.append(`body[people][${RealIndex}][address_number]`, Member.Direccion.Altura );
            formData.append(`body[people][${RealIndex}][document_number]`, Member.Documento );
            formData.append(`body[people][${RealIndex}][discount_comment]`, Member.Price.discount_comment );
            formData.append(`body[people][${RealIndex}][document_type_title]`, Member.Tipo );
            formData.append(`body[people][${RealIndex}][product]`, Member.Product);
            formData.append(`body[people][${RealIndex}][price_extra_comments]`, Member.Price.extra_comments );
            formData.append(`body[people][${RealIndex}][antecedents]`, Array.isArray(Member.Antecedentes) ? JSON.stringify(Member.Antecedentes) : JSON.stringify([Member.Antecedentes]));
            formData.append(`body[people][${RealIndex}][antecedents_comments]`, typeof Member.AntecedentesComentarios === 'object' ? JSON.stringify(Member.AntecedentesComentarios) : Member.AntecedentesComentarios);
            Member.EmergencyContacts.forEach((c, idx) => {
                formData.append(`body[people][${RealIndex}][emergency_contacts][${idx}][Nombre]`, c.Nombre);
                formData.append(`body[people][${RealIndex}][emergency_contacts][${idx}][Apellido]`, c.Apellido);
                formData.append(`body[people][${RealIndex}][emergency_contacts][${idx}][Parentesco]`, c.Parentesco);
                formData.append(`body[people][${RealIndex}][emergency_contacts][${idx}][CodArea]`, c.CodArea);
                formData.append(`body[people][${RealIndex}][emergency_contacts][${idx}][Celular]`, c.Celular);
            });
        }
        
        const { Envio } = Conecta.state;
        AppendShipping(formData, Envio);

        formData.append(`discount`, Price.discount );
        formData.append(`subtotal`, Total );
      

        if(MethodPayment === "Credit")
        {
            const {Credit} = Misc.state.Payment
            const {Expires, Token, Card,DocumentType,Email,EmailConfirm} = Credit;

            const formattedCardNumber = Card.replace(/^(\d{6})\d{6}(\d{4})$/, '$1XXXXXX$2');

            formData.append(`body[payment][cvv]`, "" );
            formData.append(`body[payment][card]`, formattedCardNumber );
            formData.append(`body[payment][token]`, Token );
            formData.append(`body[payment][total]`, Total );
            formData.append(`body[payment][method]`, "1" );
            formData.append(`body[payment][validthru]`, Expires );
            formData.append(`body[payment][card_number]`, "" );
            formData.append(`body[payment][document_type]`, getDocumentoID(DocumentType) );
            formData.append(`body[payment][owner_lastname]`, Credit.LastName );
            formData.append(`body[payment][document_number]`, Credit.DocumentNumber );
            formData.append(`body[payment][owner_firstname]`, Credit.FirstName );

            formData.append(`body[email_confirm]`, Email );
            formData.append(`body[email_reconfirm]`, EmailConfirm );
        }
        else if(MethodPayment === "Debit")
        {
            const {Debit} = Misc.state.Payment
            const {Email,EmailConfirm,DocumentNumber,DocumentType,FirstName,LastName} = Debit;
            formData.append(`body[payment][CBU]`, "" );
            formData.append(`body[payment][document_type]`, getDocumentoID(DocumentType) );
            formData.append(`body[payment][owner_lastname]`, LastName );
            formData.append(`body[payment][document_number]`, DocumentNumber );
            formData.append(`body[payment][owner_firstname]`, FirstName );

            formData.append(`body[email_confirm]`, Email );
            formData.append(`body[email_reconfirm]`, EmailConfirm );
        }
        else
        {
            // Sin método de pago = cotización (WhatsappPromotor): no existe pago todavía,
            // no guardar un bloque payment vacío que en el admin parece un pago fallido
            formData.append(`body[cotizacion]`, 1 );
        }

        Cupon ? formData.append(`body[coupon_code]`, Cupon.alias ) : formData.append(`body[coupon_code]`, "" ) ;
        Cupon ? formData.append(`body[coupon]`, JSON.stringify(Cupon)) : formData.append(`body[coupon]`, "" ) ;

        formData.append(`[discount_comment]`, Price.discount_comment );
        formData.append(`[collect_people_data]`, 0 );
        formData.append(`[totalPersonDiscount]`, Price.discount );

        const FormPayloadCooked = InyectTrackingCookies(formData);

        await Session.post(`/tracking/${CookieTracking}`,  FormPayloadCooked);
    
    } 
    catch (error) 
    {
        
    }
}

export const saveResponsePayment = async (Response,productID) =>
{
    const Session        = getSession();
    const CookieTracking = $cookies.get("tracking");

    var Body = Response;

    // El listado del admin toma nombre/email/documento de cualquier fila de la sesión:
    // sumar la identidad del titular también acá para que la sesión nunca quede anónima
    if (String(productID) === "4" && Response && typeof Response === "object")
    {
        const {Nombre,Apellido,Email,Tipo,Documento,CodigoArea,Celular} = Conecta.state;
        Body = {
            ...Response,
            "firstname": Nombre,
            "lastname": Apellido,
            "email": Email,
            "document_type": getDocumentoID(Tipo),
            "document_number": String(Documento),
            "phone": `${CodigoArea}-${Celular}`
        };
    }

    const Payload = {
        "body": Body,
        "step": "5",
        "productid": productID
    }

    console.log(Payload,"tracking error");
    //formData.append('productid', productID);

    //const FormPayloadCooked = InyectTrackingCookies(formData);


    await Session.post(`/tracking/${CookieTracking}`,  Payload);
}

